import styled from '@emotion/styled';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { LangSwitcher } from '../components/form-items/lang-switcher';
import { APP_LANGUAGES } from '../constants/app-lang';

const Wrapper = styled('div')`
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled('div')`
  padding: 20px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.COLORS.BLACK._300};
`;

const HomeButton = styled('a')`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid rgba(0, 224, 194, 0.4);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: #00e0c2;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.25s ease;
  letter-spacing: 0.3px;

  &:hover {
    background: rgba(0, 224, 194, 0.15);
    border-color: rgba(0, 224, 194, 0.7);
    color: #fff;
    box-shadow: 0 0 20px rgba(0, 224, 194, 0.2);
  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`;

export const AuthLayout: FC = () => {
  return (
    <Wrapper>
      <HomeButton
        href="https://edu.qblocks.ai/"
        rel="noopener noreferrer"
      >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
        Home
      </HomeButton>
      {APP_LANGUAGES.length > 1 && <LangSwitcher />}
      <Inner>
        <Outlet />
      </Inner>
    </Wrapper>
  );
};
